import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const LastModifiedValue = ({
  value
}) => /*#__PURE__*/_jsx(FormattedDateTime, {
  value: value,
  format: "LLL",
  type: "userTz"
});
export const FormType = ({
  value
}) => value ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: `dashboard.table.tags.${value}`
}) : /*#__PURE__*/_jsx("span", {
  children: "-"
});